import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { useUserRoleDescriptionsListSuspense } from "gen/endpoints/users/users";
import { useTranslation } from "react-i18next";
import Descriptions from "shared/components/descriptions/Descriptions";

export interface UserRoleDefinitionsModalProps {
  onCloseComplete(): void;
}

export const UserRoleDefinitionsModal: React.FC<
  UserRoleDefinitionsModalProps
> = ({ onCloseComplete }) => {
  const { t } = useTranslation(["common", "enums", "settings"]);
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const { data: descriptionList } = useUserRoleDescriptionsListSuspense();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={onCloseComplete}
      scrollBehavior="inside"
      size="6xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t("settings:roleDescriptions")}
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <Descriptions>
            {descriptionList.map((description) => (
              <Descriptions.Item
                key={description.role}
                label={description.role}
              >
                {description.description}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button colorScheme="dismiss" onClick={onClose} autoFocus={true}>
            {t("common:close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
